

















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Swipe, SwipeItem, Lazyload,Dialog } from 'vant';
Vue.use(Swipe)
.use(SwipeItem)
.use(Lazyload)
.use(Dialog)

@Component
export default class Blh extends Vue{

    images=[{
        url:'/video',
        imgUrl:'http://yths.zgftlm.com/static/banner1.png'
    }]

    navs=[{
        url:'/health',
        imgUrl:'http://yths.zgftlm.com/static/jkzl.png'
    },{
        url:'healthAdvisory',
        imgUrl:'http://yths.zgftlm.com/static/jkzx.png'
    },{
         url:'/videoList',
        imgUrl:'http://yths.zgftlm.com/static/bjjt.png'
    }]
    zb = {
        url:'',
        imgUrl:'http://yths.zgftlm.com/static/zb.png'
    }

    yxmf = [{
        title:'养心及养神观点',
        imgUrl:'http://yths.zgftlm.com/static/jkys.jpeg',
        date:'2020-09-04',
        url:'https://mp.weixin.qq.com/s/sdZDqMo3q3UXSKDEOieABg'
    },{
        title:'养心即静心',
        imgUrl:'http://yths.zgftlm.com/static/jkys.jpeg',
        date:'2020-09-04',
        url:'https://mp.weixin.qq.com/s/svL8Sdwsw73cWoMRIsHJ4Q'
    },{
        title:'养心和精气神的交养关系',
        imgUrl:'http://yths.zgftlm.com/static/jkys.jpeg',
        date:'2020-09-04',
        url:'https://mp.weixin.qq.com/s/v9cXVOb4WClUAnmGd-oKmA'
    }]

    slys= [{
        title:'秋后吃蜜不吃姜，吃果不吃瓜！相互提醒！',
        imgUrl:'http://yths.zgftlm.com/static/fm.jpg',
        url:'https://mp.weixin.qq.com/s/w-v9_djgWDKuPZWmC5hXXg'
    },{
        title:'桑叶+黑芝麻，能让老人从头到脚都通补',
        imgUrl:'http://yths.zgftlm.com/static/hzm.jpg',
        url:'https://mp.weixin.qq.com/s/dvE4-bS2dw9U1Y26bSdAUw'
    },{
        title:'它是“黄金果”，全身上下是宝',
        imgUrl:'http://yths.zgftlm.com/static/ng.jpg',
        url:'https://mp.weixin.qq.com/s/xuDuRhdRYSSjdA3_858V1A'
    },{
        title:'秋喝一碗汤，远离秋季病  ',
        imgUrl:'http://yths.zgftlm.com/static/tang.jpg',
        url:'https://mp.weixin.qq.com/s/aQty_S88xJtYaGK5gfb6jg'
    }]

    mounted(){
        document.title="百家讲堂"
    }

    ts(){
        // Dialog({ message: '功能暂未开放！' });
        window.location.href='http://shop.yths.zgftlm.com'
    }
    goNav(nav:any){
                  this.$router.push(nav.url);

    }
}

